import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { AllUserQueryParams, EmployeeRequestPage } from '../../../shared/models/request.model';
import { ApiResponse, SelectDropdown } from '../../../shared/models/common.model';
import {initialResponseData, UserActiveStatus, UserActiveStatusOptions} from '../../../shared/utils/constants';
import useSpinnerLoader from '../../../shared/components/spinner-loader';
import TableHeaderOrdering, { Header, OrderData } from '../../../shared/components/table-header-ordering';
import TableRowNoData from '../../../shared/components/molecules/commons/table-row-no-data';
import { RequestService } from '../../../shared/services/request-service';
import { AxiosError } from 'axios/index';
import { notificationService } from '../../../shared/services/notification-service';
import { Button, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faSearch } from '@fortawesome/free-solid-svg-icons';
import PaginationForm from '../../../shared/components/molecules/commons/pagination-form';
import InputSelect from '../../../shared/components/atoms/input-select';
import Moment from "moment-timezone";
import Toggle from 'react-toggle';
import { UserService } from '../../../shared/services/user-service';
import ConfirmModal from '../../../shared/components/molecules/modals/confirm-modal';
import { hasPermission } from '../../../shared/utils/roles';
import { useAuth } from '../../../shared/authentications/auth-context';
import MonthYearInput from '../../../shared/components/atoms/month-year-input';
import * as XLSX from 'xlsx';
import { department_offices_name_Options, fetchDepartmentsOfficeNameOptions, fetchDivisionGroupOfficeNameOptions, fetchDepartmentsNameOptions, fetchLeaveTypeOptions, fetchPositionNameOptions, division_group_office_name_Options, departments_name_Options, position_name_Options } from '../../Report/OptionsDropDown';

interface EmployeeRequestPageProps extends EmployeeRequestPage {
  onChangeStatus: (status: boolean, id: any) => void;
}

const Over90DaysUsersPage: FC = () => {
  const [queryParams, setQueryParams] = useState<any>({
    search: '',
    is_active: null,
    status: "เกิน90วัน",
    ordering_field: '',
    ordering: '',
    department_offices_name: "",
    division_group_office_name: "",
    structure_departments_name: "",
    position_name: "",
    date: null,
    page: 1,
    page_size: 10,
  });
  const [data, setData] = useState<ApiResponse<EmployeeRequestPage>>(initialResponseData);
  const [dataExport, setDataExport] = useState<ApiResponse<EmployeeRequestPage>>(initialResponseData);
  const {loaderComponent, isLoading, startLoading, stopLoading} = useSpinnerLoader();

  const headers: Header[] = [
    {
      label: 'Username',
      field: 'username',
      order: null,
      isOrder: true,
    },
    {
      label: 'ชื่อ - นามสกุล',
      field: 'full_name_th',
      order: null,
      isOrder: true,
    },
    {
      label: 'อีเมล',
      field: 'email',
      order: null,
      isOrder: true,
    },
    {
      label: 'เบอร์โทรศัพท์',
      field: 'phone',
      order: null,
      isOrder: true,
    },
    {
      label: 'สถานะ',
      field: 'is_active',
      order: null,
      isOrder: true,
    },
    {
      label: 'ไม่เข้าใช้งาน',
      field: '',
      order: null,
      isOrder: false,
    },
    {
      label: 'ใช้งานครั้งล่าสุด',
      field: 'login_last_date',
      order: null,
      isOrder: true,
    }
  ];

  useEffect(() => {
    fetchData();

  }, [queryParams.ordering, queryParams.page_size, queryParams.page, queryParams.department_offices_name, queryParams.division_group_office_name, queryParams.structure_departments_name, queryParams.position_name, queryParams.date]);

  const fetchData = async () => {
    startLoading();
    try {
      const result = await RequestService.getAllUser(queryParams);
      const resultExcel = await RequestService.getAllUser({...queryParams,page: 1,page_size: 100000,date: null});
      setData(result);
      setDataExport(resultExcel);
    } catch (error) {
      const err = error as AxiosError;
      notificationService.dangerNotification('โหลดข้อมูลไม่สำเร็จ', err.message);
    } finally {
      stopLoading();
    }
  };

  const onChangePageSize = (page_size: number) => {
    setQueryParams({
      ...queryParams,
      page_size: page_size
    });
  };

  const onChangePage = (page: number) => {
    setQueryParams({
      ...queryParams,
      page: page
    });
  };
  const tableRowNoData = () => {
    if (data.rows.length === 0) {
      return <TableRowNoData colspan={7}/>;
    }
    return null;
  }

  const onChangeOrder = (orderData: OrderData) => {
    setQueryParams({
      ...queryParams,
      ordering_field: orderData.field,
      ordering: orderData.order,
    });
  };


  const onGetService = (status: boolean) => {
    if (status)
      return UserService.onActive;
    return UserService.onInActive;
  };

  const onChangeStatus = async (status: boolean, id: any) => {
    startLoading();
    try {
      const data = await onGetService(status)(id);
      notificationService.successNotification('เปลี่ยนสถานะเรียบร้อย', '');
    } catch (error) {
      const err = error as AxiosError;
      notificationService.dangerNotification('โหลดข้อมูลไม่สำเร็จ', err.message);
    } finally {
      stopLoading();
    }
  };

  const exportToExcelAll = () => {
    const DataForExcel = [];
    DataForExcel.push(headers.map(item => item.label));
    dataExport.rows?.map((data: EmployeeRequestPage) => {
      DataForExcel.push([
        data.user?.username || '-',
        data.full_name_th || '-',
        data.user?.email || '-',
        data.phone || '-',
        data.user?.is_active ? 'เปิดใช้งาน' : 'ปิดใช้งาน',
        data.user?.last_login ? 
          `${Moment().diff(Moment(data.user.last_login), 'days')} วัน` : '-',
        data.user?.last_login ? 
          Moment(data.user.last_login).add(543, 'year').format('DD/MM/YYYY HH:mm:ss') : '-'
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(DataForExcel);

     // กำหนดความกว้างคอลัมน์ตาม headers
     ws['!cols'] = [
      { wch: 15 },  // Username
      { wch: 30 },  // ชื่อ - นามสกุล
      { wch: 35 },  // อีเมล
      { wch: 15 },  // เบอร์โทรศัพท์
      { wch: 15 },   // สถานะ
      { wch: 15 },  // ไม่เข้าใช้งาน
      { wch: 25 }  // ใช้งานครั้งล่าสุด
  ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'รายงานผู้ใช้งานเกิน90วัน.xlsx');
  };

  useEffect(() => {
    return () => {
      setQueryParams({
        search: '',
        is_active: null,
        ordering_field: '',
        ordering: '',
        page: 1,
        page_size: 10,
      })
    };
  }, []);

  useEffect(() => {
    fetchDepartmentsOfficeNameOptions();
    fetchDivisionGroupOfficeNameOptions();
    fetchDepartmentsNameOptions();
    fetchPositionNameOptions();
  }, []);



  return <>
    {loaderComponent}

    <div className="row">
        <div className="flex-row col-sm-12 col-md-3">
          <label className="form-label">วันที่</label>
          <MonthYearInput
            date={queryParams.date ? new Date(queryParams.date) : null}
            onChange={(date) => {
              const newDate = Moment(date).format("YYYY-MM");

              setQueryParams({
                ...queryParams,
                page: 1,
                date: newDate,
              });
            }}
            required={true}
          />
        </div>

                <div className="flex-row col-sm-12 col-md-3">
                  <label className="form-label">สำนัก/ฝ่าย</label>
                  <InputSelect
                    value={queryParams.department_offices_name}
                    options={department_offices_name_Options}
                    placeholder=""
                    name="is_active"
                    onChange={(e: any) => {
                      setQueryParams((prevState:any) => {
                        return {
                          ...prevState,
                          department_offices_name: e.value.value || "",
                        };
                      });
                    }}
                    required={true}
                    isValidateError={false}
                  />
                </div>
      
                <div className="flex-row col-sm-12 col-md-3">
                  <label className="form-label">กอง/กลุ่ม</label>
                  <InputSelect
                    value={queryParams.division_group_office_name}
                    options={division_group_office_name_Options}
                    placeholder=""
                    name="is_active"
                    onChange={(e: any) => {
                      setQueryParams((prevState:any) => {
                        return {
                          ...prevState,
                          division_group_office_name: e.value.value || "",
                        };
                      });
                    }}
                    required={true}
                    isValidateError={false}
                  />
                </div>
             
        <div className="flex-row col-sm-12 col-md-3">
          <label className="form-label">แผนก</label>
          <InputSelect
            value={queryParams.structure_departments_name}
            options={departments_name_Options}
            placeholder=""
            name="is_active"
            onChange={(e: any) => {
              setQueryParams((prevState:any) => {
                return {
                  ...prevState,
                  structure_departments_name: e.value.value || "",
                };
              });
            }}
            required={true}
            isValidateError={false}
          />
        </div>
        <div className="flex-row col-sm-12 col-md-3">
          <label className="form-label">ตำแหน่ง</label>
          <InputSelect
            value={queryParams.position_name}
            options={position_name_Options}
            placeholder=""
            name="is_active"
            onChange={(e: any) => {
              setQueryParams((prevState:any) => {
                return {
                  ...prevState,
                  position_name: e.value.value || "",
                };
              });
            }}
            required={true}
            isValidateError={false}
          />
        </div>
        <div className="col-sm-12 col-md-3 d-flex align-items-end mt-4">
          <input
            className="form-control"
            type="text"
            value={queryParams.search as string}
            placeholder="ค้นหาจากชื่อ..."
            name="search"
            onChange={(e) => {
              setQueryParams((prevState:any) => {
                return {
                  ...prevState,
                  search: e.target.value || "",
                };
              });
            }}
          />
        </div>
        <div className="col-sm-12 col-md-3 d-flex align-items-end mt-3 gap-3">
          <Button
            variant="primary"
            type="button"
            className="d-block px-4"
            onClick={fetchData}
          >
            <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
          </Button>
        </div>
        <div className="col-sm-12 col-md-3 d-flex align-items-end mt-3 gap-3 justify-content-end">
            <Button variant="primary" className="btn-action btn-mof-primary me-2" onClick={exportToExcelAll}>
                    <FontAwesomeIcon icon={faFileExport} className="me-2"/>
                    Export
                </Button>
            </div>
      </div>

    <div className="overflow-auto mt-3">
      <Table striped bordered hover>
        <thead>
        <TableHeaderOrdering headers={headers} onChangeOrder={onChangeOrder} isShow={true}/>
        </thead>
        <tbody>
        {
          data.rows.map((data, index) => {
            return <AllUserRow key={data.id} {...data} onChangeStatus={onChangeStatus}/>;
          })
        }
        {tableRowNoData()}
        </tbody>
      </Table>
    </div>
    <div className="">
      <PaginationForm current_page={queryParams.page} count={data.count} page_size={queryParams.page_size}
                      onChangePageSize={onChangePageSize} onChangePage={onChangePage}/>
    </div>
  </>;
};

const AllUserRow: FC<EmployeeRequestPageProps> = ({id, user, full_name_th, phone, onChangeStatus}) => {
  const { permission} = useAuth();
  const [showConfirmModal, setConfirmModal] = useState(false);
  const [targetStatus, setTargetStatus] = useState(user.is_active);

  const getLastLoginFormat = () => {
    return user.last_login ?
      Moment(user.last_login).add(543, 'year').format('DD/MM/YYYY HH:mm:ss')
      : '';
  };

  const getLastLoginDiffDate = () => {
    return user.last_login ?
      `${Moment().diff(Moment(user.last_login), 'days')} วัน`
      : '';
  };

  const onChange = async (e: any) => {
    setConfirmModal(true);
  };

  const handleCloseModal = () => {
    setConfirmModal(false);

  };

  const onConfirm = () => {
    setConfirmModal(false);
    onChangeStatus(!targetStatus, user.id);
    setTargetStatus(!targetStatus);
  };

  const displayModal = () => {
    if (showConfirmModal) {
      return <ConfirmModal
        show={showConfirmModal}
        title={'ยืนยันการเปลี่ยนสถานะ'}
        description={'คุณแน่ใจหรือไม่ว่าต้องเปลี่ยนสถานะ'}
        onHide={handleCloseModal}
        onConfirm={onConfirm}
      />;
    }
    return;
  };

  return <tr>
    {displayModal()}
    <td>{user.username}</td>
    <td>{full_name_th}</td>
    <td>{user.email}</td>
    <td>{phone}</td>
    <td>
      <Toggle
        id="is_active"
        name="is_active"
        disabled={!hasPermission(permission, ['employee_actives'], 'approve')}
        checked={targetStatus}
        icons={false}
        onChange={onChange}/>
    </td>
    <td>
      {getLastLoginDiffDate()}
    </td>
    <td>
      {getLastLoginFormat()}
    </td>
  </tr>;
};

export default Over90DaysUsersPage;
